import numeral from 'numeral';

export function convertToArabicNumber(numericValue: number, useCommas: boolean = false, allowExtraDecimal = false): string {
  if (numericValue === undefined || numericValue === null) return '';

  const arabicMap: { [key: string]: string } = {
    '0': '٠', '1': '١', '2': '٢', '3': '٣', '4': '٤',
    '5': '٥', '6': '٦', '7': '٧', '8': '٨', '9': '٩',
    ',': ',',
    '.': '.'
};
  let sourceString = `${numericValue}`;
  if(useCommas) {
    sourceString = numeral(numericValue).format('0,0.00');
  }
  if(allowExtraDecimal) {
    sourceString = numeral(numericValue).format('0,0.00[000]');
  }
  const regex = useCommas ? /[0-9.,]/g : /[0-9]/g;
  return sourceString.replace(regex, (char: string) => {
    return arabicMap[char] || char;
  });
}